import React, { useEffect, useState } from "react";
import { Input, Spinner } from "reactstrap";

import stile from "./stile.module.css";

function SafeguardingSegnalazioni(props) {

    const PAGINE = {
        caricamentoDati: 1,
        elencoSegnalazioni: 2,
        nuovaSegnalazione: 3,
        dettaglioSegnalazione: 4
    };

    const [pagina, setPagina] = useState(PAGINE.caricamentoDati);

    const [elencoSegnalazioni, setElencoSegnalazioni] = useState([]);
    const [elencoMessaggi, setElencoMessaggi] = useState([]);

    const [idSegnalazione, setIdSegnalazione] = useState(0);
    const [dataOraSegnalazione, setDataOraSegnalazione] = useState("");

    const [testoNuovaSegnalazione, setTestoNuovaSegnalazione] = useState("");
    const [testoRisposta, setTestoRisposta] = useState("");

    const [invioInCorso, setInvioInCorso] = useState(false);

    const responsabile = props.identitaSelezionata.resp_safeguarding === 1;

    useEffect(() => {
        scaricaElencoSegnalazioni();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    // gestione del tasto BACK
    useEffect(() => {
        if (props.flagRichiestaBack) {
            props.setFlagRichiestaBack(false);
            props.callback(props.PAGINECLIENTI.home);
        } 
    }, [props.flagRichiestaBack])

    function primaLettura(jsonLettura) {

        if (
            jsonLettura === null ||
            jsonLettura === undefined ||
            jsonLettura === ""
        ) {
            return null;
        }

        try {
            const letture = typeof jsonLettura === "string"
                ? JSON.parse(jsonLettura)
                : jsonLettura;

            if (!Array.isArray(letture) || letture.length === 0) {
                return null;
            }

            const prima = letture[0];

            if (!prima || !prima.DATAORA) {
                return null;
            }

            return prima;
        } catch (errore) {
            console.log("JSON_LETTURA non valido:", jsonLettura);
            return null;
        }
    }

    function statoLetturaMessaggio(messaggio) {

        const lettura = primaLettura(messaggio.JSON_LETTURA);

        if (lettura === null) {
            return {
                letto: false,
                testo: "Non letto"
            };
        }

        return {
            letto: true,
            testo: "Letto il " + formattaDataOra(lettura.DATAORA)
        };
    }    

    function gestisciErroreOperazione(valoreDiRitorno) {

        if (valoreDiRitorno.verifvers === 0) {
            if (props.callbackAggiornaApp) {
                props.callbackAggiornaApp();
            }
            return true;
        }

        if (valoreDiRitorno.risultatoOperazione === 2) {
            if (props.callback && props.PAGINECLIENTI) {
                props.callback(props.PAGINECLIENTI.login);
            }
            return true;
        }

        if (valoreDiRitorno.risultatoOperazione !== 1) {
            window.alert(
                "Operazione fallita: sistema momentaneamente non disponibile. " +
                "Se il problema persiste, contattare l'assistenza tecnica"
            );
            return true;
        }

        return false;
    }

    function gestisciErroreFetch() {
        window.alert(
            "Impossibile comunicare con il server. " +
            "Verifica la connessione e riprova."
        );

        if (props.callback && props.PAGINECLIENTI) {
            props.callback(props.PAGINECLIENTI.login);
        }
    }

    function scaricaElencoSegnalazioni() {

        setPagina(PAGINE.caricamentoDati);

        const requestOptions = {
            method: "POST",
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify({
                op: "safeguardingLeggi",
                elenco: 1,
                tipo: responsabile ? "responsabile" : "utente",
                emak: props.emak,
                sessionId: props.sessionId
            })
        };

        fetch(props.UrlBackend, requestOptions)
            .then(risposta => risposta.json())
            .then(
                valoreDiRitorno => {

                    if (gestisciErroreOperazione(valoreDiRitorno)) {
                        return;
                    }

                    setElencoSegnalazioni(
                        Array.isArray(valoreDiRitorno.risultatoRitorno)
                            ? valoreDiRitorno.risultatoRitorno
                            : []
                    );

                    setPagina(PAGINE.elencoSegnalazioni);
                },
                () => {
                    gestisciErroreFetch();
                }
            );
    }

    function apriSegnalazione(segnalazione) {

        setIdSegnalazione(parseInt(segnalazione.ID, 10));
        setDataOraSegnalazione(segnalazione.DATAORA);
        setTestoRisposta("");
        setPagina(PAGINE.caricamentoDati);

        const requestOptions = {
            method: "POST",
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify({
                op: "safeguardingLeggi",
                idsegnalazione: segnalazione.ID,
                emak: props.emak,
                sessionId: props.sessionId
            })
        };

        fetch(props.UrlBackend, requestOptions)
            .then(risposta => risposta.json())
            .then(
                valoreDiRitorno => {

                    if (gestisciErroreOperazione(valoreDiRitorno)) {
                        return;
                    }

                    setElencoMessaggi(
                        Array.isArray(valoreDiRitorno.risultatoRitorno)
                            ? valoreDiRitorno.risultatoRitorno
                            : []
                    );

                    setPagina(PAGINE.dettaglioSegnalazione);
                },
                () => {
                    gestisciErroreFetch();
                }
            );
    }

    function nuovaSegnalazione() {
        setTestoNuovaSegnalazione("");
        setPagina(PAGINE.nuovaSegnalazione);
    }

    function confermaNuovaSegnalazione() {

        const testo = testoNuovaSegnalazione.trim();

        if (testo === "") {
            window.alert("Scrivi il testo della segnalazione.");
            return;
        }

        setInvioInCorso(true);

        const requestOptions = {
            method: "POST",
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify({
                op: "safeguardingSegnala",
                testo: testo,
                emak: props.emak,
                sessionId: props.sessionId
            })
        };

        fetch(props.UrlBackend, requestOptions)
            .then(risposta => risposta.json())
            .then(
                valoreDiRitorno => {

                    setInvioInCorso(false);

                    if (gestisciErroreOperazione(valoreDiRitorno)) {
                        return;
                    }

                    setTestoNuovaSegnalazione("");
                    scaricaElencoSegnalazioni();
                },
                () => {
                    setInvioInCorso(false);
                    gestisciErroreFetch();
                }
            );
    }

    function inviaRisposta() {

        const testo = testoRisposta.trim();

        if (testo === "") {
            window.alert("Scrivi il messaggio da inviare.");
            return;
        }

        setInvioInCorso(true);

        const requestOptions = {
            method: "POST",
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify({
                op: "safeguardingRispondi",
                idsegnalazione: idSegnalazione,
                testo: testo,
                emak: props.emak,
                sessionId: props.sessionId
            })
        };

        fetch(props.UrlBackend, requestOptions)
            .then(risposta => risposta.json())
            .then(
                valoreDiRitorno => {

                    setInvioInCorso(false);

                    if (gestisciErroreOperazione(valoreDiRitorno)) {
                        return;
                    }

                    setTestoRisposta("");

                    apriSegnalazione({
                        ID: idSegnalazione,
                        DATAORA: dataOraSegnalazione
                    });
                },
                () => {
                    setInvioInCorso(false);
                    gestisciErroreFetch();
                }
            );
    }

    function tornaElenco() {
        setIdSegnalazione(0);
        setDataOraSegnalazione("");
        setElencoMessaggi([]);
        setTestoRisposta("");
        scaricaElencoSegnalazioni();
    }

    function formattaDataOra(dataOra) {

        if (!dataOra) {
            return "";
        }

        const parti = dataOra.split("T");

        if (parti.length !== 2) {
            return dataOra;
        }

        const data = parti[0].split("-");

        if (data.length !== 3) {
            return dataOra;
        }

        const ora = parti[1].substring(0, 5);

        return data[2] + "/" + data[1] + "/" + data[0] + " " + ora;
    }

    function testoAnteprima(segnalazione) {

        if (segnalazione.TESTO && segnalazione.TESTO.trim() !== "") {
            const testo = segnalazione.TESTO.trim();

            if (testo.length > 100) {
                return testo.substring(0, 100) + "…";
            }

            return testo;
        }

        return "Segnalazione del " + formattaDataOra(segnalazione.DATAORA);
    }

    function messaggioScrittoDallUtente(messaggio) {

        if (
            props.identitaSelezionata.idpersona !== undefined &&
            props.identitaSelezionata.idpersona !== null
        ) {
            return (
                parseInt(messaggio.IDPERSONA, 10) ===
                parseInt(props.identitaSelezionata.idpersona, 10)
            );
        }

        return true;
    }

    function descrizioneAutoreMessaggio(messaggio) {

        const nome = messaggio.NOME
            ? messaggio.NOME.trim()
            : "";

        const cognome = messaggio.COGNOME
            ? messaggio.COGNOME.trim()
            : "";

        const nominativo = (nome + " " + cognome).trim();

        if (nominativo !== "") {
            return nominativo;
        }

        return responsabile
            ? "Segnalatore"
            : "Tu";
    }

    function visualizzaCaricamento() {
        return (
            <div
                style={{
                    minHeight: 180,
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    gap: 10
                }}
            >
                <Spinner size="sm" />
                <span>Caricamento...</span>
            </div>
        );
    }

    function visualizzaElenco() {
        return (
            <>
                <div
                    style={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        gap: 10,
                        marginBottom: 16
                    }}
                >
                    <div>
                        <h4 style={{ margin: 0 }}>
                            {responsabile
                                ? "Segnalazioni ricevute"
                                : "Le tue segnalazioni"
                            }
                        </h4>

                        <div
                            style={{
                                marginTop: 4,
                                color: "#666",
                                fontSize: 14
                            }}
                        >
                            {responsabile ? (
                                "Gestisci le segnalazioni degli utenti."
                            ) : (
                                <>
                                    Hai subito o visto un comportamento che ti ha fatto sentire a disagio o che ritieni scorretto? Clicca “Nuova segnalazione” per segnalare episodi di{" "}
                                    <strong>abuso, violenza, molestia, discriminazione, bullismo o altri comportamenti inappropriati</strong>.
                                    {" "}La segnalazione verrà inviata al responsabile incaricato dalla società di gestire queste segnalazioni. La segnalazione è anonima: chi la riceverà non saprà chi sei, a meno che tu non scelga di scriverlo. Non utilizzare questa funzione per segnalare guasti o altri disservizi.
                                </>
                            )}
                        </div>
                    </div>                    

                    {!responsabile && (
                    <div
                        style={{
                            display: "flex",
                            marginTop: 10,
                            marginBottom: 10,
                            marginLeft: 10,
                            marginRight: 10
                        }}
                    >
                        <div
                            className={[
                                stile.baVerdeSoft,
                                stile.baNormale,
                                stile.baFlex
                            ].join(" ")}
                            style={{textAlign:"center"}}
                            onClick={nuovaSegnalazione}
                        >
                            Nuova segnalazione
                        </div>
                    </div>
                    )}

                </div>

                {elencoSegnalazioni.length === 0 ? (
                    <div
                        style={{
                            padding: 25,
                            textAlign: "center",
                            backgroundColor: "#f7f7f7",
                            border: "1px solid #e5e5e5",
                            borderRadius: 10
                        }}
                    >
                        <div style={{ fontWeight: 600 }}>
                            Non hai ancora inviato segnalazioni
                        </div>

                        <div
                            style={{
                                marginTop: 6,
                                color: "#666",
                                fontSize: 14
                            }}
                        >
                            Premi “Nuova segnalazione” per inviarne una.
                        </div>
                    </div>
                ) : (
                    <div
                        style={{
                            display: "flex",
                            flexDirection: "column",
                            gap: 10
                        }}
                    >
                        {elencoSegnalazioni.map(segnalazione => (
                            <button
                                key={segnalazione.ID}
                                type="button"
                                onClick={() =>
                                    apriSegnalazione(segnalazione)
                                }
                                style={{
                                    width: "100%",
                                    padding: 15,
                                    textAlign: "left",
                                    backgroundColor: "#fff",
                                    border: "1px solid #ddd",
                                    borderRadius: 10,
                                    cursor: "pointer"
                                }}
                            >
                                <div
                                    style={{
                                        display: "flex",
                                        justifyContent: "space-between",
                                        alignItems: "center",
                                        gap: 10
                                    }}
                                >
                                    <div
                                        style={{
                                            fontWeight: 600,
                                            color: "#222"
                                        }}
                                    >
                                        {testoAnteprima(segnalazione)}
                                    </div>

                                    <div
                                        aria-hidden="true"
                                        style={{
                                            fontSize: 22,
                                            color: "#777"
                                        }}
                                    >
                                        ›
                                    </div>
                                </div>

                                <div
                                    style={{
                                        marginTop: 6,
                                        color: "#666",
                                        fontSize: 13
                                    }}
                                >
                                    {responsabile ? "Generata" : "Inviata"}
                                    {" "}il{" "}
                                    {formattaDataOra(
                                        segnalazione.DATAORA
                                    )}
                                </div>
                            </button>
                        ))}
                    </div>
                )}
            </>
        );
    }

    function visualizzaNuovaSegnalazione() {
        return (
            <>
                <div
                    style={{
                        display: "flex",
                        alignItems: "center",
                        gap: 10,
                        marginBottom: 18
                    }}
                >
                    <div
                        className={[
                            stile.baAzzurro,
                            stile.baNormale
                        ].join(" ")}
                        onClick={() => {
                            if (!invioInCorso) {
                                tornaElenco();
                            }
                        }}
                    >
                        <img
                            className={stile.iconaPiccolaQuadrata}
                            src={require("./annulla.png")}
                            alt=""
                        />                            
                        &nbsp;Elenco
                    </div>

                    <h4 style={{ margin: 0 }}>
                        Nuova segnalazione
                    </h4>
                </div>

                <div
                    style={{
                        padding: 15,
                        marginBottom: 15,
                        backgroundColor: "#f5f7fa",
                        borderRadius: 10,
                        color: "#444",
                        fontSize: 14,
                        lineHeight: 1.5
                    }}
                >
                    Descrivi ciò che vuoi segnalare. Il messaggio sarà inoltrato in modo anonimo ai responsabili safeguarding incaricati.
                </div>

                <label
                    htmlFor="testoNuovaSegnalazione"
                    style={{
                        display: "block",
                        marginBottom: 6,
                        fontWeight: 600
                    }}
                >
                    Testo della segnalazione
                </label>

                <Input
                    id="testoNuovaSegnalazione"
                    type="textarea"
                    rows="8"
                    value={testoNuovaSegnalazione}
                    disabled={invioInCorso}
                    onChange={event =>
                        setTestoNuovaSegnalazione(
                            event.target.value
                        )
                    }
                    placeholder="Scrivi qui la tua segnalazione..."
                    style={{
                        resize: "vertical",
                        minHeight: 160
                    }}
                />

                <div
                    style={{
                        display: "flex",
                        marginTop: 10,
                        marginBottom: 10,
                        marginLeft: 10,
                        marginRight: 10,
                        flexDirection: "row"
                    }}
                >
                    <div
                        className={[
                            stile.baRossoSoft,
                            stile.baNormale
                        ].join(" ")}
                        onClick={() => {
                            if (!invioInCorso) {
                                tornaElenco();
                            }
                        }}
                    >
                        <div className={stile.spazioIconaPiccola}>
                            <img
                                className={stile.iconaPiccolaQuadrata}
                                src={require("./annullabianco.png")}
                                alt=""
                            />
                        </div>
                        Annulla
                    </div>

                    <div
                        className={[
                            stile.baVerdeSoft,
                            stile.baNormale,
                            stile.baFlex,
                            stile.baSecondoBottone
                        ].join(" ")}
                        onClick={() => {
                            if (
                                !invioInCorso &&
                                testoNuovaSegnalazione.trim() !== ""
                            ) {
                                confermaNuovaSegnalazione();
                            }
                        }}
                        style={{
                            opacity:
                                invioInCorso ||
                                testoNuovaSegnalazione.trim() === ""
                                    ? 0.5
                                    : 1,
                            pointerEvents:
                                invioInCorso ||
                                testoNuovaSegnalazione.trim() === ""
                                    ? "none"
                                    : "auto"
                        }}
                    >
                        <div className={stile.spazioIconaPiccola}>
                            <img
                                className={stile.iconaPiccolaQuadrata}
                                src={require("./modificabianco.png")}
                                alt=""
                            />
                        </div>

                        {invioInCorso
                            ? "Invio..."
                            : "Invia segnalazione"}
                    </div>
                </div>
            </>
        );
    }

    function visualizzaDettaglio() {
        return (
            <>
                <div
                    style={{
                        display: "flex",
                        alignItems: "center",
                        gap: 10,
                        marginBottom: 6
                    }}
                >
                    <div
                        style={{
                            display: "flex",
                            marginTop: 10,
                            marginBottom: 10,
                            marginLeft: 10,
                            marginRight: 10
                        }}
                    >
                        <div
                            className={[
                                stile.baAzzurro,
                                stile.baNormale
                            ].join(" ")}
                            onClick={() => {
                                if (!invioInCorso) {
                                    tornaElenco();
                                }
                            }}
                        >
                            <img
                                className={stile.iconaPiccolaQuadrata}
                                src={require("./annulla.png")}
                                alt=""
                            />                            
                            &nbsp;Elenco
                        </div>
                    </div>

                    <h4 style={{ margin: 0 }}>
                        Segnalazione
                    </h4>
                </div>

                <div
                    style={{
                        marginBottom: 18,
                        marginLeft: 2,
                        color: "#666",
                        fontSize: 13
                    }}
                >
                    Aperta il {formattaDataOra(dataOraSegnalazione)}
                </div>

                <div
                    style={{
                        display: "flex",
                        flexDirection: "column",
                        gap: 12,
                        marginBottom: 20
                    }}
                >
                    {elencoMessaggi.length === 0 ? (
                        <div
                            style={{
                                padding: 20,
                                textAlign: "center",
                                backgroundColor: "#f7f7f7",
                                borderRadius: 10,
                                color: "#666"
                            }}
                        >
                            Non ci sono messaggi da visualizzare.
                        </div>
                    ) : (
                        elencoMessaggi.map(messaggio => {

                            const mioMessaggio =
                                messaggioScrittoDallUtente(messaggio);

                            const statoLettura =
                                statoLetturaMessaggio(messaggio);

                            return (
                                <div
                                    key={messaggio.ID}
                                    style={{
                                        display: "flex",
                                        justifyContent:
                                            mioMessaggio
                                                ? "flex-end"
                                                : "flex-start"
                                    }}
                                >
                                    <div
                                        style={{
                                            maxWidth: "85%",
                                            padding: "11px 14px",
                                            borderRadius: 12,
                                            backgroundColor:
                                                mioMessaggio
                                                    ? "#e6f2ff"
                                                    : "#f0f0f0",
                                            border:
                                                mioMessaggio
                                                    ? "1px solid #c8e2ff"
                                                    : "1px solid #ddd",
                                            whiteSpace: "pre-wrap",
                                            overflowWrap: "break-word"
                                        }}
                                    >
                                        <div
                                            style={{
                                                marginBottom: 5,
                                                fontSize: 12,
                                                fontWeight: 600,
                                                color: "#555"
                                            }}
                                        >
                                            {descrizioneAutoreMessaggio(messaggio)}
                                        </div>

                                        <div
                                            style={{
                                                lineHeight: 1.45
                                            }}
                                        >
                                            {messaggio.TESTO}
                                        </div>

                                        <div
                                            style={{
                                                
                                                justifyContent: "space-between",
                                                alignItems: "center",
                                                gap: 15,
                                                marginTop: 7,
                                                fontSize: 11
                                            }}
                                        >
                                            <div
                                                style={{
                                                    color: "#777",
                                                    textAlign: "right"
                                                }}
                                            >
                                                {formattaDataOra(
                                                    messaggio.DATAORA
                                                )}
                                            </div>

                                            {mioMessaggio && (
                                                <div
                                                    style={{
                                                        fontWeight: statoLettura.letto
                                                            ? "normal"
                                                            : 600,
                                                        color: statoLettura.letto
                                                            ? "#777"
                                                            : "#b00020"
                                                    }}
                                                >
                                                    {statoLettura.testo}
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                </div>
                            );
                        })
                    )}
                </div>

                <div
                    style={{
                        paddingTop: 15,
                        borderTop: "1px solid #ddd"
                    }}
                >
                    <label
                        htmlFor="testoRisposta"
                        style={{
                            display: "block",
                            marginBottom: 6,
                            fontWeight: 600
                        }}
                    >
                        Aggiungi un messaggio
                    </label>

                    <Input
                        id="testoRisposta"
                        type="textarea"
                        rows="4"
                        value={testoRisposta}
                        disabled={invioInCorso}
                        onChange={event =>
                            setTestoRisposta(event.target.value)
                        }
                        placeholder="Scrivi un nuovo messaggio..."
                        style={{
                            resize: "vertical"
                        }}
                    />

                    <div
                        style={{
                            display: "flex",
                            marginTop: 10,
                            marginBottom: 10,
                            marginLeft: 10,
                            marginRight: 10
                        }}
                    >
                        <div
                            className={[
                                stile.baVerdeSoft,
                                stile.baNormale,
                                stile.baFlex
                            ].join(" ")}
                            onClick={() => {
                                if (
                                    !invioInCorso &&
                                    testoRisposta.trim() !== ""
                                ) {
                                    inviaRisposta();
                                }
                            }}
                            style={{
                                opacity:
                                    invioInCorso ||
                                    testoRisposta.trim() === ""
                                        ? 0.5
                                        : 1,
                                pointerEvents:
                                    invioInCorso ||
                                    testoRisposta.trim() === ""
                                        ? "none"
                                        : "auto"
                            }}
                        >
                            <div className={stile.spazioIconaPiccola}>
                                <img
                                    className={stile.iconaPiccolaQuadrata}
                                    src={require("./modificabianco.png")}
                                    alt=""
                                />
                            </div>

                            {invioInCorso
                                ? "Invio..."
                                : "Invia messaggio"}
                        </div>
                    </div>
                </div>
            </>
        );
    }

    return (
        <div
            className={stile.contenitorePrincipale}
            style={{ padding: 5 }}
        >
            {pagina === PAGINE.caricamentoDati &&
                visualizzaCaricamento()}

            {pagina === PAGINE.elencoSegnalazioni &&
                visualizzaElenco()}

            {pagina === PAGINE.nuovaSegnalazione &&
                visualizzaNuovaSegnalazione()}

            {pagina === PAGINE.dettaglioSegnalazione &&
                visualizzaDettaglio()}
        </div>
    );
}

export default SafeguardingSegnalazioni;